import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {pendingReceiptActions} from "./pendingReceiptSlice";
import {pendingReceiptApi} from "~/api";

function* fetchPendingReceiptList(action) {
	try {
		const response = yield call(pendingReceiptApi.gets, action.payload);
		yield put(pendingReceiptActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch pending receipt list', error);
		yield put(pendingReceiptActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(pendingReceiptActions.setFilter(action.payload));
}

export default function* pendingReceiptSaga() {
	yield takeLatest(pendingReceiptActions.fetchData.type, fetchPendingReceiptList);
	yield debounce(500, pendingReceiptActions.setFilterWithDebounce.type, handleSearchDebounce)
}
